export default "__VITE_ASSET__04140583__"